import React, { FC } from 'react'

export const Loading: FC = () => <div>LOADING!</div>
